export enum CategoryApiPath {
  getCategory = '/api/category',
}
